export default {
    methods: {
        softResetApp() {
            var app = this
            this.resetState(function () {
                if (process.env.VUE_APP_BASE === '/gastouderapp/') {
                    app.$router.push('/login/gastouder')
                } else {
                    app.$router.push('/login/user')
                }
                location.reload()
            })
        },
        resetApp() {
            var app = this
            app.$store.commit('SET_SESSION', null)
            this.clearLocalStorage()
            this.resetState(function () {
                if (process.env.VUE_APP_BASE === '/gastouderapp/') {
                    app.$router.push('/login/gastouder')
                } else {
                    app.$router.push('/login/user')
                }
                location.reload()
            })
        },
        resetForNewLogin() {
            this.clearLocalStorage();
        },
        switchToBeta() {
            if (this.app.isBeta === true) {
                alert('Je maakt al gebruik van de beta versie')
            } else {
                this.$store.commit('SET_USE_BETA', true)
                this.resetState(function () {
                    console.log('switch to beta callback')
                    console.log('redirect to: ' + 'https://' + window.location.host + '/groepsapp-beta/')
                    setTimeout(function () {
                        console.log('time out')
                        if (process.env.VUE_APP_BASE === '/groepsapp-beta/') {
                            location.href = 'https://' + window.location.host + '/groepsapp-beta/'
                        } else if (process.env.VUE_APP_BASE === '/gastouderapp-beta/') {
                            location.href = 'https://' + window.location.host + '/gastouderapp-beta/'
                        }
                    }, 100)
                })
            }
        },
        switchToStable() {
            if (this.app.isBeta === false) {
                alert('Je maakt al gebruik van de stabiele versie')
            } else {
                this.$store.commit('SET_USE_BETA', false)
                this.resetState(function () {
                    console.log('switch to stable callback')
                    console.log('redirect to: ' + 'https://' + window.location.host + '/groepsapp-beta/')
                    setTimeout(function () {
                        location.href = 'https://' + window.location.host + '/ipad/'
                    }, 100)
                })
            }
        },
        clearLocalStorage() {
            var maxIterations = 99
            var i = 0
            while (localStorage.length > 0 && i < maxIterations) {
                localStorage.clear()
                i++
            }
        }
    }
}
